import React, { useEffect, useContext, useState, useRef } from 'react';
import { useParams } from 'react-router-dom';

import {
    LinearProgress,
    Grid,
    Drawer
} from '@material-ui/core';

import {
    PageHeader
} from '../../../common';

import {
    SelectUserForm,
    UserList
} from './components';

import { PageProvider, PageContext } from './PageContext';
import { NavContext, NavRoutes } from '../../../contexts';

import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
    root: {
    },
    drawer: {
        width: "600px",
        margin: theme.spacing(2)
    }
}));

const PageContent = (props) => {
    const classes = useStyles();

    const {
        state,
        pageIsReady,
        setPageIsReady,
        isBusy,
        setIsBusy,
        getTableAsync,
        searchUsersAsync,
        addUserToTableAsync,
        removeUserFromTableAsync,
        addRoleToUserAsync,
        removeRoleForUserAsync
    } = useContext(PageContext);

    const {
        navigateTo
    } = useContext(NavContext);

    const {
        table
    } = state;

    const [isDrawerOpen, setIsDrawrOpen] = useState(false);
    const toggleDrawer = (open) => (event) => {
        if (event.type === 'keydown'
            && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }

        setIsDrawrOpen(open);
    };

    const searchUserHandler = async (value, callback) => {
        const users = await searchUsersAsync(value);
        callback(users || []);
    }

    // const formRef = useRef();
    // const addUserClickHandler = () => {
    //     if(formRef.current) {
    //         formRef.current.handleSubmit();
    //     }
    // }

    const userFormSubmitHandler = async (values, done) => {
        setIsBusy({ addUser: true });
        const { userId, roleIds } = values;
        await addUserToTableAsync({
            tableId: table.managedTableId,
            userId,
            roleIds: roleIds.map(x => parseInt(x))
        }
        );
        setIsDrawrOpen(false);
        done();
        setIsBusy({ addUser: false });
    }

    const viewUserHandler = (user) => {
        navigateTo(NavRoutes.Admin.RoleUser, [user.roleIds[0], user.userId]);
    }

    const removeUserHandler = async (user) => {
        setIsBusy({ removeUser: true });
        await removeUserFromTableAsync(table.managedTableId, user.userId);
        setIsBusy({ removeUser: false });
    }

    const toggleRoleHandler = async (user, role) => {
        setIsBusy({ toggleRole: true });
        if (user.roleIds.findIndex(x => x === role.roleId) === -1) {
            await addRoleToUserAsync({
                roleId: role.roleId,
                userId: user.userId,
                tableId: table.managedTableId
            });
        } else {
            await removeRoleForUserAsync(
                role.roleId,
                user.userId,
                table.managedTableId
            );
        }
        setIsBusy({ toggleRole: false });
    }

    const { tableId } = useParams();
    useEffect(() => {
        if (tableId) {
            getTableAsync(parseInt(tableId), true);
        }
    }, [tableId]);

    useEffect(() => {
        setPageIsReady(
            table !== null)
    }, [table]);

    return (
        <>
            {pageIsReady ?
                <div>
                    <Grid container spacing={3} className={classes.root}>
                        <Grid item xs={12}>
                            <PageHeader
                                add
                                addButtonText="Add User"
                                title={table.tableName}
                                subtitle="Manage users permissions for this table"
                                disabled={isBusy()}
                                onAddClick={toggleDrawer(true)}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <UserList
                                disabled={isBusy()}
                                onViewUser={viewUserHandler}
                                onRemoveUser={removeUserHandler}
                                onToggleRole={toggleRoleHandler}
                            />
                        </Grid>
                    </Grid>
                    <Drawer anchor="right" open={isDrawerOpen} onClose={toggleDrawer(false)}>
                        <div className={classes.drawer}>
                            <SelectUserForm
                                //formRef={formRef}                     
                                disabled={isBusy()}
                                onSearchUsers={searchUserHandler}
                                onSubmit={userFormSubmitHandler}
                            />
                        </div>
                    </Drawer>
                </div>

                :
                <LinearProgress />
            }
        </>
    );
}

export const TableUsersPage = () => {

    return (
        <PageProvider>
            <PageContent />
        </PageProvider>
    );
}